export default {
  SET_ROLES (state, payload) {
    state.roles = payload
  }
}
